(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1995],{

/***/ 23929:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/recruitments",
      function () {
        return __webpack_require__(89538);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 41299:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ Button; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var styled_jsx_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87603);
/* harmony import */ var styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(styled_jsx_style__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var src_utils_classNames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25746);




var Button = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.memo)(function(param) {
    var text = param.text, onClick = param.onClick, disabled = param.disabled, _size = param.size, size = _size === void 0 ? "default" : _size, _active = param.active, active = _active === void 0 ? true : _active, testId = param.testId, className = param.className, _type = param.type, type = _type === void 0 ? "button" : _type;
    var buttonSizeStyle = "button-".concat(size);
    var buttonColorStyle = active ? "text-white bg-green border-none" : "text-white bg-gray3";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
        type: type,
        onClick: onClick,
        disabled: !!disabled,
        "data-testid": testId,
        className: "jsx-77ae3419ea903928" + " " + ((0,src_utils_classNames__WEBPACK_IMPORTED_MODULE_3__/* .classNames */ .A)(className, "disabled:bg-gray", "disabled:cursor-not-allowed", buttonSizeStyle, buttonColorStyle) || ""),
        children: [
            text,
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default()), {
                id: "77ae3419ea903928",
                children: ".button-default.jsx-77ae3419ea903928{outline:none;-webkit-border-radius:34px;-moz-border-radius:34px;border-radius:34px;width:280px;height:50px;padding:11px 0;font-size:18px;font-weight:600;text-align:center;margin:15px 0}.button-sm.jsx-77ae3419ea903928{padding:0px 14px 2px 14px;font-size:14px;text-align:center;outline:none;-webkit-border-radius:34px;-moz-border-radius:34px;border-radius:34px;width:auto;height:27px}.button-md.jsx-77ae3419ea903928{padding:0px 14px 2px 14px;font-size:14px;text-align:center;outline:none;-webkit-border-radius:34px;-moz-border-radius:34px;border-radius:34px;width:145px;height:35px}.button-full.jsx-77ae3419ea903928{padding:0px 14px 2px 14px;font-size:18px;font-weight:600;text-align:center;outline:none;-webkit-border-radius:34px;-moz-border-radius:34px;border-radius:34px;width:100%;height:50px}"
            })
        ]
    });
});


/***/ }),

/***/ 21629:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);



function HeadTag(param) {
    var title = param.title, description = param.description, keywords = param.keywords, canonical = param.canonical, noindex = param.noindex, ogUrl = param.ogUrl, ogTitle = param.ogTitle, ogDescription = param.ogDescription, ogImage = param.ogImage, ogSiteName = param.ogSiteName, ogType = param.ogType;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: title
            }),
            description ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                content: description,
                name: "description"
            }) : null,
            keywords ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                content: keywords,
                name: "keywords"
            }) : null,
            canonical ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                content: canonical,
                name: "canonical"
            }) : null,
            noindex ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "robots",
                content: "noindex"
            }) : null,
            ogUrl ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:url",
                content: ogUrl
            }) : null,
            ogTitle ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:title",
                content: ogTitle
            }) : null,
            ogDescription ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:description",
                content: ogDescription
            }) : null,
            ogImage ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image",
                content: ogImage
            }) : null,
            ogSiteName ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:site_name",
                content: ogSiteName
            }) : null,
            ogType ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:type",
                content: ogType
            }) : null,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "icon",
                type: "image/x-icon",
                sizes: "16x16",
                href: "/images/favicon16.ico"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "icon",
                type: "image/x-icon",
                sizes: "32x32",
                href: "/images/favicon32.ico"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "icon",
                type: "image/x-icon",
                sizes: "48x48",
                href: "/images/favicon48.ico"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "icon",
                type: "image/png",
                sizes: "96x96",
                href: "/images/favicon.png"
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (HeadTag);


/***/ }),

/***/ 76110:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ Loader; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var styled_jsx_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87603);
/* harmony import */ var styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(styled_jsx_style__WEBPACK_IMPORTED_MODULE_1__);


var Loader = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "jsx-dff670cd55ecbc10" + " " + "loader",
        children: [
            "Loading...",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default()), {
                id: "dff670cd55ecbc10",
                children: ".loader.jsx-dff670cd55ecbc10{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-webkit-justify-content:center;-moz-box-pack:center;-ms-flex-pack:center;justify-content:center;margin:50px auto}"
            })
        ]
    });
};


/***/ }),

/***/ 84642:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ Modal; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var client_components_common_icons__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41322);





var Modal = function(_param) {
    var children = _param.children, title = _param.title, onClear = _param.onClear, onClose = _param.onClose, dataTestId = _param.dataTestId, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "children",
        "title",
        "onClear",
        "onClose",
        "dataTestId"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        className: "fixed top-0 left-0 h-full z-50",
        "data-testid": dataTestId
    }, rest), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "bg-black opacity-50 h-full w-screen"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "absolute overflow-y-auto bg-white top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full h-full",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "top-0 left-0 flex items-center justify-between w-full bg-white sticky py-4 px-5 border-b-[0.6px] border-solid border-gray",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "cursor-pointer ".concat(!onClose && "invisible"),
                                onClick: onClose,
                                "data-testid": "modal-close-button",
                                "aria-label": "モーダルを閉じるボタン",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(client_components_common_icons__WEBPACK_IMPORTED_MODULE_1__/* .CloseIcon */ .Tw, {
                                    width: 12,
                                    height: 15
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "".concat(onClear ? "ml-6" : "mx-auto"),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    className: "text-light-black font-bold text-center",
                                    "data-testid": "modal-title",
                                    children: title
                                })
                            }),
                            onClear ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    className: "text-green text-sm font-bold cursor-pointer",
                                    onClick: onClear,
                                    "data-testid": "modal-reset-button",
                                    children: "リセット"
                                })
                            }) : null
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        children: children
                    })
                ]
            })
        ]
    }));
};


/***/ }),

/***/ 52238:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ RecruitmentTag; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var styled_jsx_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87603);
/* harmony import */ var styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(styled_jsx_style__WEBPACK_IMPORTED_MODULE_1__);


var RecruitmentTag = function(param) {
    var name = param.name, backgroundColor = param.backgroundColor, borderColor = param.borderColor, fontColor = param.fontColor;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default().dynamic([
                    [
                        "a02428ebfa8650ae",
                        [
                            fontColor,
                            backgroundColor,
                            borderColor
                        ]
                    ]
                ]) + " " + "mr-2 text-xs font-bold rounded p-1 tag",
                children: name
            }),
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default()), {
                id: "a02428ebfa8650ae",
                dynamic: [
                    fontColor,
                    backgroundColor,
                    borderColor
                ],
                children: ".tag.__jsx-style-dynamic-selector{color:".concat(fontColor, ";background-color:").concat(backgroundColor, ";border:1px solid ").concat(borderColor, "}")
            })
        ]
    });
};


/***/ }),

/***/ 1784:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ BonusLabel; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

var BonusLabel = function(param) {
    var bonus = param.bonus, className = param.className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: bonus && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "flex justify-center border border-red rounded-[5px]" + " " + className,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: "text-red text-sm font-semibold",
                children: bonus
            })
        })
    });
};


/***/ }),

/***/ 22902:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "VI": function() { return /* binding */ DeadLine; }
/* harmony export */ });
/* unused harmony exports createCountDownLabel, DeadLineCountDown */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react_countdown__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(98130);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);



var createCountDownLabel = function(days, hours, minutes, seconds) {
    if (days !== 0) return "応募締切まで残り".concat(days, "日!!");
    if (hours !== 0) return "応募締切まで残り".concat(hours, "時間").concat(minutes, "分").concat(seconds, "秒!!");
    if (minutes !== 0) return "応募締切まで残り".concat(minutes, "分").concat(seconds, "秒!!");
    return "応募締切まで残り".concat(seconds, "秒!!");
};
var DeadLineCountDown = function(param) {
    var days = param.days, hours = param.hours, minutes = param.minutes, seconds = param.seconds, completed = param.completed, isRecruitmentCompleted = param.isRecruitmentCompleted;
    var label = createCountDownLabel(days, hours, minutes, seconds);
    if (isRecruitmentCompleted || completed) return null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "w-full text-center py-1 bg-red text-white font-bold text-sm tracking-wide",
        children: label
    });
};
var DeadLine = function(param) {
    var deadLineDate = param.deadLineDate, isRecruitmentCompleted = param.isRecruitmentCompleted;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_countdown__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP, {
        date: deadLineDate,
        renderer: function(param) {
            var days = param.days, hours = param.hours, minutes = param.minutes, seconds = param.seconds, completed = param.completed;
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(DeadLineCountDown, {
                days: days,
                hours: hours,
                minutes: minutes,
                seconds: seconds,
                completed: completed,
                isRecruitmentCompleted: isRecruitmentCompleted
            });
        }
    });
};


/***/ }),

/***/ 16181:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "A": function() { return /* binding */ RecruitmentListItem; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/node_modules/styled-jsx/style.js
var style = __webpack_require__(87603);
var style_default = /*#__PURE__*/__webpack_require__.n(style);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/client/generated/index.ts + 3 modules
var generated = __webpack_require__(15229);
// EXTERNAL MODULE: ./src/client/components/common/icons.tsx
var icons = __webpack_require__(41322);
// EXTERNAL MODULE: ./src/client/components/common/RecruitmentTag.tsx
var RecruitmentTag = __webpack_require__(52238);
// EXTERNAL MODULE: ./node_modules/@material-ui/lab/esm/Rating/Rating.js + 5 modules
var Rating = __webpack_require__(46702);
;// CONCATENATED MODULE: ./src/client/components/recruitments/RecruitmentList/Item/Review.tsx



var Review = function(param) {
    var review = param.review;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Rating/* default */.Z, {
                value: review === null || review === void 0 ? void 0 : review.rate,
                precision: 0.1,
                size: "small",
                readOnly: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "text-sm font-bold ml-1",
                children: review === null || review === void 0 ? void 0 : review.rate
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "text-xs text-gray3 ml-1",
                children: review === null || review === void 0 ? void 0 : review.description
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/client/components/recruitments/RecruitmentList/Item/NotExistReview.tsx



var NotExistReview = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Rating/* default */.Z, {
                value: 0,
                max: 1,
                size: "small",
                disabled: true,
                readOnly: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "text-xs text-light-gray3 ml-1",
                children: "まだ評価がありません"
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/client/components/recruitments/RecruitmentList/Item/DeadLine.tsx
var DeadLine = __webpack_require__(22902);
// EXTERNAL MODULE: ./src/client/components/recruitments/BonusLabel.tsx
var BonusLabel = __webpack_require__(1784);
;// CONCATENATED MODULE: ./src/client/components/recruitments/RecruitmentList/Item/index.tsx










var RecruitmentListItem = function(param) {
    var recruitment = param.recruitment;
    var tags = recruitment.tags, capacity = recruitment.capacity, endsAt = recruitment.endsAt, facility = recruitment.facility, travelAllowanceLabel = recruitment.travelAllowanceLabel, remainingRecruitmentNumbers = recruitment.remainingRecruitmentNumbers, representativeImage = recruitment.representativeImage, salary = recruitment.salary, startsAt = recruitment.startsAt, tasks = recruitment.tasks, title = recruitment.title, state = recruitment.state, review = recruitment.review, deadline = recruitment.deadline, bonus = recruitment.bonus;
    var isRecruitmentCompleted = state === generated/* RecruitmentState.Closed */.q6J.Closed;
    var fetchWorkDayOfWeek = function(workday) {
        var DAY_OF_WEEK = [
            "日",
            "月",
            "火",
            "水",
            "木",
            "金",
            "土"
        ];
        var daySlice = workday.slice(0, 10);
        var daySplit = daySlice.split("-");
        var fetchDayOfWeekNumber = new Date(parseInt(daySplit[0]), parseInt(daySplit[1]) - 1, parseInt(daySplit[2])).getDay();
        return DAY_OF_WEEK[fetchDayOfWeekNumber];
    };
    var workdayFormatter = function(workday) {
        var daySlice = workday.slice(0, 10);
        var daySplit = daySlice.split("-");
        return daySplit;
    };
    var workTimeFormatter = function(workTime) {
        var timeSlice = workTime.slice(11, 19);
        var timeSplit = timeSlice.split(":");
        return timeSplit;
    };
    var workTime = "".concat(workdayFormatter(startsAt)[1], "/").concat(workdayFormatter(startsAt)[2], "(").concat(fetchWorkDayOfWeek(startsAt), ") ").concat(workTimeFormatter(startsAt)[0], ":").concat(workTimeFormatter(startsAt)[1], " - ").concat(workTimeFormatter(endsAt)[0], ":").concat(workTimeFormatter(endsAt)[1]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "jsx-51702489add8c7a" + " " + "shadow-[0px_2px_5px_rgba(0,0,0,0.2)] max-w-[335px] bg-white rounded-xl",
                children: [
                    isRecruitmentCompleted && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "jsx-51702489add8c7a" + " " + "absolute z-0",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* RecruitmentClosedLabel */.m5, {
                            width: 75,
                            height: 75
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: representativeImage || undefined,
                        alt: "",
                        loading: "lazy",
                        className: "jsx-51702489add8c7a" + " " + "w-[335px] h-[259px] object-cover bg-cover rounded-[12px_12px_0_0] card_top"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DeadLine/* DeadLine */.VI, {
                        deadLineDate: new Date(deadline),
                        isRecruitmentCompleted: isRecruitmentCompleted
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "jsx-51702489add8c7a" + " " + "my-[10px] mx-3 pb-4",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(BonusLabel/* BonusLabel */.F, {
                                className: "mb-[7px]",
                                bonus: bonus
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "jsx-51702489add8c7a" + " " + "leading-[25px] tracking-[0px] text-light-black font-bold text-left",
                                children: title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "jsx-51702489add8c7a" + " " + "my-2",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "jsx-51702489add8c7a" + " " + "flex flex-wrap mt-5",
                                    children: tags.map(function(o, i) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(RecruitmentTag/* RecruitmentTag */.g, {
                                            name: o.name,
                                            backgroundColor: o.color.background,
                                            fontColor: o.color.font,
                                            borderColor: o.color.border
                                        }, i);
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "jsx-51702489add8c7a" + " " + "mb-6 flex flex-col gap-0.5",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RecruitmentItem, {
                                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* WorkTaskIcon */.xT, {
                                            width: 15
                                        }),
                                        content: tasks
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RecruitmentItem, {
                                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* WorkAddressIcon */.EX, {
                                            width: 15
                                        }),
                                        content: facility.address
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RecruitmentItem, {
                                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* WorkTimeIcon */.eH, {
                                            width: 15
                                        }),
                                        content: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "jsx-51702489add8c7a" + " " + "text-sm text-light-black font-bold",
                                                    children: workTime
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "jsx-51702489add8c7a" + " " + "ml-auto",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "jsx-51702489add8c7a" + " " + "text-xl font-semibold text-light-black",
                                                            children: salary.toLocaleString()
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "jsx-51702489add8c7a" + " " + "text-sm",
                                                            children: "円"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "jsx-51702489add8c7a",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "jsx-51702489add8c7a" + " " + "text-xs text-light-gray3",
                                                                children: travelAllowanceLabel
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "jsx-51702489add8c7a" + " " + "flex items-center mb-1",
                                children: review ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Review, {
                                    review: review
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(NotExistReview, {})
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "jsx-51702489add8c7a" + " " + "flex justify-between",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "jsx-51702489add8c7a" + " " + "text-xs text-green flex items-center font-bold mt-1",
                                        children: facility.name
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "jsx-51702489add8c7a",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "jsx-51702489add8c7a" + " " + "text-xs mr-2 text-light-black font-bold",
                                                children: "募集人数"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                className: "jsx-51702489add8c7a" + " " + "text-xs text-red",
                                                children: [
                                                    "残り",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "jsx-51702489add8c7a" + " " + "text-base",
                                                        children: remainingRecruitmentNumbers
                                                    }),
                                                    "/",
                                                    capacity,
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "jsx-51702489add8c7a",
                                                        children: "名"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            (0,jsx_runtime.jsx)((style_default()), {
                id: "51702489add8c7a",
                children: ".card_top.jsx-51702489add8c7a{background:-webkit-linear-gradient(top,rgba(0,0,0,1e-4)0%,rgba(0,0,0,.400623)100%);background:-moz-linear-gradient(top,rgba(0,0,0,1e-4)0%,rgba(0,0,0,.400623)100%);background:-o-linear-gradient(top,rgba(0,0,0,1e-4)0%,rgba(0,0,0,.400623)100%);background:linear-gradient(180deg,rgba(0,0,0,1e-4)0%,rgba(0,0,0,.400623)100%)}"
            })
        ]
    });
};
var RecruitmentItem = function(param) {
    var icon = param.icon, content = param.content;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "text-[13px] mt-[5px] text-black flex items-center text-left",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-xs mr-1 mt-px",
                children: icon
            }),
            content
        ]
    });
};


/***/ }),

/***/ 89538:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ recruitments; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/client/components/Footer/ActionsFooter.tsx + 2 modules
var ActionsFooter = __webpack_require__(76852);
// EXTERNAL MODULE: ./src/client/components/common/HeadTag.tsx
var HeadTag = __webpack_require__(21629);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/format/index.js + 21 modules
var format = __webpack_require__(91513);
;// CONCATENATED MODULE: ./src/client/contexts/recruitments/RecruitmentList/index.tsx




var createInitialState = function(currentDate, areaIds) {
    var currentDateText = (0,format/* default */.Z)(currentDate, "yyyy-MM-dd");
    return {
        searchQueryParams: {
            date: currentDateText,
            areaIds: null,
            licenseIds: null,
            jobBenefitIds: null,
            workingHourOptionIds: null,
            maximumWorkingHours: null,
            jobTaskIds: null,
            maximumDailyWage: null,
            minimumDailyWage: null,
            facilityFeatureIds: null,
            sortOptionId: null,
            onlyRecruiting: null
        },
        // クエリのdateに合わせており、「日付」だけほしい
        currentDateText: currentDateText,
        // ワーカーWebの募集検索は都道府県選択が最低でも1つは必要なので、都道府県がない場合は都道府県選択を強制
        ui: areaIds && areaIds.length > 0 ? {
            displayMode: "list",
            modeHistory: [
                "list"
            ]
        } : {
            displayMode: "area-modal",
            modeHistory: [
                "list",
                "area-modal"
            ]
        }
    };
};
// 検索系の各種コンポーネントがRecruitmentListContextやuseRecruitmentListContextを使うための便宜上の措置
// 実際に募集検索画面の初期状態はdefaultStateがそのまま使われず、
// URLのクエリパラメータからページ着地時の検索条件のContextStateを復元して、
// useReducerに復元したContextStateを食わせる
// 詳細は src/pages/recruitment.tsx を参照
var defaultState = createInitialState(new Date(), null);
var RecruitmentListContext = /*#__PURE__*/ (0,react.createContext)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, defaultState), {
    dispatch: function() {}
}));
var useRecruitmentListContext = function() {
    return (0,react.useContext)(RecruitmentListContext);
};

// EXTERNAL MODULE: ./node_modules/next/node_modules/styled-jsx/style.js
var style = __webpack_require__(87603);
var style_default = /*#__PURE__*/__webpack_require__.n(style);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./src/client/components/recruitments/SearchForm/AreaSelect.tsx



var AreaSelect = function(param) {
    var value = param.value, labelIcon = param.labelIcon, onClick = param.onClick;
    var selectedValueText = (0,react.useMemo)(function() {
        var text = typeof value === "string" ? value : (value === null || value === void 0 ? void 0 : value.join(", ")) || "";
        return text.length > 14 ? "".concat(text.substr(0, 14), " ...") : text;
    }, [
        value
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "jsx-f04a370159829944" + " " + "select-wrapper flex",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "jsx-f04a370159829944",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "jsx-f04a370159829944" + " " + "mt-1",
                        children: labelIcon && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "jsx-f04a370159829944" + " " + "select-label-icon-wrapper",
                            children: labelIcon
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    onClick: onClick,
                    className: "jsx-f04a370159829944" + " " + "ml-3",
                    children: value && value.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "jsx-f04a370159829944",
                        children: selectedValueText
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "jsx-f04a370159829944",
                        children: "エリアを選択"
                    })
                }),
                (0,jsx_runtime.jsx)((style_default()), {
                    id: "f04a370159829944",
                    children: ".select-wrapper.jsx-f04a370159829944{width:80%}@media(min-width:800px){.area-select.jsx-f04a370159829944{width:100%;max-width:1022px}.select-wrapper.jsx-f04a370159829944{width:100%}.select-label-wrapper.jsx-f04a370159829944{width:10%}.select-input-wrapper.jsx-f04a370159829944{width:100%}}"
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/client/hooks/recruitment/RecruitmentList/useUrlQueryParams.ts
// GraphQL の SearchRecruitment Query の inputから 募集検索のURLのクエリパラメータを生成する
var useUrlQueryParams = function(param) {
    var date = param.date, areaIds = param.areaIds, licenseIds = param.licenseIds, facilityFeatureIds = param.facilityFeatureIds, jobBenefitIds = param.jobBenefitIds, sortOptionId = param.sortOptionId, minimumDailyWage = param.minimumDailyWage, maximumDailyWage = param.maximumDailyWage, workingHourOptionIds = param.workingHourOptionIds, maximumWorkingHours = param.maximumWorkingHours, jobTaskIds = param.jobTaskIds, onlyRecruiting = param.onlyRecruiting;
    var createUrlQuery = function() {
        var query = {};
        if (date) {
            query.date = date;
        }
        if (areaIds) {
            query.area_ids = areaIds;
        }
        if (licenseIds) {
            query.license_ids = licenseIds;
        }
        if (facilityFeatureIds) {
            query.facility_feature_ids = facilityFeatureIds;
        }
        if (jobBenefitIds) {
            query.job_benefit_ids = jobBenefitIds;
        }
        if (workingHourOptionIds) {
            query.working_hour_option_ids = workingHourOptionIds;
        }
        if (sortOptionId) {
            query.sort_option_id = sortOptionId;
        }
        if (typeof maximumWorkingHours === "number") {
            query.maximum_working_hours = maximumWorkingHours + "";
        }
        if (minimumDailyWage) {
            query.minimum_daily_wage = minimumDailyWage.toString();
        }
        if (maximumDailyWage) {
            query.maximum_daily_wage = maximumDailyWage.toString();
        }
        if (jobTaskIds) {
            query.job_task_ids = jobTaskIds;
        }
        if (onlyRecruiting) {
            query.only_recruiting = "true";
        }
        return query;
    };
    return {
        urlQueryParams: createUrlQuery()
    };
};

// EXTERNAL MODULE: ./src/client/components/common/icons.tsx
var icons = __webpack_require__(41322);
;// CONCATENATED MODULE: ./src/client/components/recruitments/Checkbox.tsx



var Checkbox = /*#__PURE__*/ (0,react.memo)(function(param) {
    var label = param.label, checked = param.checked, onClick = param.onClick, checkIconWidth = param.checkIconWidth, checkIconHeight = param.checkIconHeight, labelFontSize = param.labelFontSize;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "inline-flex items-center",
        onClick: onClick,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "bg-white box-border rounded mr-2 ".concat(checkIconWidth ? "w-[".concat(checkIconWidth, "px]") : "w-5", " ").concat(checkIconHeight ? "h-[".concat(checkIconHeight, "px]") : "h-5", " ").concat(!checked && "border border-solid border-bank-gray"),
                children: checked && /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* CheckboxCheckIcon */.T0, {
                    width: checkIconWidth !== null && checkIconWidth !== void 0 ? checkIconWidth : 20,
                    height: checkIconHeight !== null && checkIconHeight !== void 0 ? checkIconHeight : 20,
                    dataTestId: "recruitments-search-modal-checkbox-icon-".concat(label)
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-black text-center font-normal ".concat(labelFontSize ? "text-[".concat(labelFontSize, "px]") : "text-sm"),
                children: label
            })
        ]
    });
});

// EXTERNAL MODULE: ./src/client/generated/index.ts + 3 modules
var generated = __webpack_require__(15229);
;// CONCATENATED MODULE: ./src/client/components/recruitments/SearchForm/SortButton.tsx



var defaultName = "並び順";
var SortButton = function(param) {
    var sortOptionId = param.sortOptionId, sortOptions = param.sortOptions, onClick = param.onClick;
    var ref;
    var sortName = ((ref = sortOptions === null || sortOptions === void 0 ? void 0 : sortOptions.find(function(option) {
        return option.id === sortOptionId;
    })) === null || ref === void 0 ? void 0 : ref.name) || defaultName;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex my-5 ml-6",
        onClick: onClick,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* SortIcon */.fz, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "text-xs my-auto ml-2 ".concat(sortName !== defaultName && "text-light-black font-bold", " "),
                children: sortName
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/client/components/recruitments/SearchForm/index.tsx











var SearchForm = function() {
    var ref = useRecruitmentListContext(), searchQueryParams = ref.searchQueryParams, dispatch = ref.dispatch;
    var areaIds = searchQueryParams.areaIds, onlyRecruiting = searchQueryParams.onlyRecruiting, sortOptionId = searchQueryParams.sortOptionId;
    var ref1 = (0,generated/* useAreaTreeQuery */.aDY)({
        fetchPolicy: "cache-first"
    }), areaIdData = ref1.data;
    var ref2 = (0,generated/* useSortOptionListQuery */.Ulk)({
        fetchPolicy: "cache-first"
    }), sortOptionsData = ref2.data;
    var router = (0,next_router.useRouter)();
    var urlQueryParams = (0,react.useMemo)(function() {
        return useUrlQueryParams((0,_object_spread/* default */.Z)({}, searchQueryParams));
    }, [
        searchQueryParams
    ]).urlQueryParams;
    var handleClickAreaSelect = function() {
        dispatch({
            type: "changeDisplayMode",
            payload: {
                displayMode: "area-modal"
            }
        });
    };
    var handleClickFilterMore = function() {
        dispatch({
            type: "changeDisplayMode",
            payload: {
                displayMode: "search-modal"
            }
        });
    };
    var handleClickOnlyRecruiting = function() {
        dispatch({
            type: "changeOnlyRecruiting",
            payload: {
                onlyRecruiting: !onlyRecruiting
            }
        });
    };
    (0,react.useEffect)(function() {
        router.push({
            query: urlQueryParams
        }, {
            // @ts-ignore
            pathname: router.query.name,
            query: urlQueryParams
        }, {
            shallow: true
        });
    }, [
        urlQueryParams
    ]);
    var showSortSettingModal = function() {
        dispatch({
            type: "changeDisplayMode",
            payload: {
                displayMode: "sort-setting-modal"
            }
        });
    };
    var isFilterEnabled = Object.keys(searchQueryParams).filter(function(key) {
        return key !== "date";
    }).length > 0;
    var areaIdsSelectedValue = (0,react.useMemo)(function() {
        var selectedArray = [];
        areaIdData === null || areaIdData === void 0 ? void 0 : areaIdData.areaTree.regions.map(function(o) {
            return o.areaLList.filter(function(x) {
                if (areaIds === null || areaIds === void 0 ? void 0 : areaIds.includes(x.id)) {
                    selectedArray.push(x.name);
                }
            });
        });
        return selectedArray;
    }, [
        areaIds,
        areaIdData
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "my-4 mx-3",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex justify-between",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(AreaSelect, {
                            value: areaIdsSelectedValue,
                            labelIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* SearchGrassIcon */.qC, {
                                width: 15
                            }),
                            onClick: handleClickAreaSelect
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-col text-sm mb-3.5 items-center",
                            onClick: handleClickFilterMore,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "relative px-3",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* FilterIcon */.k1, {
                                            width: 21,
                                            height: 20
                                        }),
                                        isFilterEnabled && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "absolute top-0 right-0",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* MarupochiIcon */.Ab, {
                                                width: 10
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "text-xs",
                                    children: "絞り込み"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "border-b-gray border-b border-solid"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex ml-4 my-4",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox, {
                        label: "募集中のみ",
                        checked: !!onlyRecruiting,
                        onClick: handleClickOnlyRecruiting,
                        checkIconWidth: 16,
                        checkIconHeight: 16,
                        labelFontSize: 12
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SortButton, {
                        sortOptionId: sortOptionId,
                        sortOptions: (sortOptionsData === null || sortOptionsData === void 0 ? void 0 : sortOptionsData.sortOptionList.options) || [],
                        onClick: showSortSettingModal
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(70655);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react-infinite-scroller/index.js
var react_infinite_scroller = __webpack_require__(246);
var react_infinite_scroller_default = /*#__PURE__*/__webpack_require__.n(react_infinite_scroller);
// EXTERNAL MODULE: ./src/client/hooks/useCustomSnackBar.ts
var useCustomSnackBar = __webpack_require__(86868);
// EXTERNAL MODULE: ./src/utils/paths.ts
var paths = __webpack_require__(8319);
// EXTERNAL MODULE: ./src/client/components/common/Loader.tsx
var Loader = __webpack_require__(76110);
// EXTERNAL MODULE: ./src/client/components/recruitments/RecruitmentList/Item/index.tsx + 2 modules
var Item = __webpack_require__(16181);
;// CONCATENATED MODULE: ./src/client/components/recruitments/RecruitmentList/NotFound.tsx




var NotFound = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                className: "jsx-30107d5aaf4a5d65" + " " + "not-found",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "jsx-30107d5aaf4a5d65" + " " + "text-center",
                        children: "この日の仕事が見つかりませんでした"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "jsx-30107d5aaf4a5d65" + " " + "mt-12",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* NoScheduleIcon */.A5, {
                            width: 300,
                            margin: "0 auto"
                        })
                    })
                ]
            }),
            (0,jsx_runtime.jsx)((style_default()), {
                id: "30107d5aaf4a5d65",
                children: ".not-found.jsx-30107d5aaf4a5d65{margin-top:50px;display:block}"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/utils/searchCondition.ts
var canSearch = function(props) {
    return props.prefectureIds != null && props.prefectureIds.length > 0;
};

// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useQuery.js + 1 modules
var useQuery = __webpack_require__(37887);
;// CONCATENATED MODULE: ./src/client/components/recruitments/RecruitmentList/index.tsx


















var RecruitmentList = function() {
    var enqueueErrorSnackbar = (0,useCustomSnackBar/* useCustomSnackBar */.F)().enqueueErrorSnackbar;
    var searchQueryParams = useRecruitmentListContext().searchQueryParams;
    var ref = (0,useQuery/* useQuery */.a)(generated/* RecruitmentSearchDocument */.kEf, {
        variables: {
            data: (0,_object_spread/* default */.Z)({}, searchQueryParams)
        },
        skip: !canSearch({
            prefectureIds: searchQueryParams.areaIds
        }),
        onError: function(e) {
            enqueueErrorSnackbar(e);
        }
    }), data = ref.data, loading = ref.loading, fetchMore = ref.fetchMore;
    var cursor = data === null || data === void 0 ? void 0 : data.recruitmentSearch.paging.nextCursor;
    var recruitments = (data === null || data === void 0 ? void 0 : data.recruitmentSearch.recruitments) || [];
    var handleLoadMore = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (loading || cursor == null) return [
                        2
                    ];
                    return [
                        4,
                        fetchMore({
                            variables: {
                                data: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, searchQueryParams), {
                                    pagingCursor: cursor
                                })
                            }
                        })
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    }), [
        loading,
        cursor,
        fetchMore,
        searchQueryParams
    ]);
    if (loading) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Loader/* Loader */.a, {});
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
        className: "jsx-94a01c30dc0628f0",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((react_infinite_scroller_default()), {
                pageStart: 0,
                loadMore: handleLoadMore,
                hasMore: cursor != null,
                threshold: 100,
                loader: /*#__PURE__*/ (0,jsx_runtime.jsx)(Loader/* Loader */.a, {}, 0),
                children: recruitments.length == 0 && cursor == null ? /*#__PURE__*/ (0,jsx_runtime.jsx)(NotFound, {}) : recruitments.map(function(o, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        className: "jsx-94a01c30dc0628f0",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "".concat(paths/* paths.recruitments.index */.H.recruitments.index, "/[id]"),
                            as: "".concat(paths/* paths.recruitments.index */.H.recruitments.index, "/").concat(encodeURIComponent(o.id)),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                className: "jsx-94a01c30dc0628f0",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Item/* RecruitmentListItem */.A, {
                                    recruitment: o
                                })
                            })
                        })
                    }, index);
                })
            }),
            (0,jsx_runtime.jsx)((style_default()), {
                id: "94a01c30dc0628f0",
                children: "ul.jsx-94a01c30dc0628f0{list-style:none;margin:0 20px 20px 20px;padding:0}li.jsx-94a01c30dc0628f0{display:-webkit-inline-box;display:-webkit-inline-flex;display:-moz-inline-box;display:-ms-inline-flexbox;display:inline-flex;width:100%;-webkit-box-pack:center;-webkit-justify-content:center;-moz-box-pack:center;-ms-flex-pack:center;justify-content:center}a.jsx-94a01c30dc0628f0{margin-top:30px;text-decoration:none}.no-recruitings-found.jsx-94a01c30dc0628f0{margin-top:50px;display:block}.order-condition.jsx-94a01c30dc0628f0{margin-left:23px}.order-button.jsx-94a01c30dc0628f0{margin-right:10px}@media(min-width:800px){ul.jsx-94a01c30dc0628f0{width:100%;max-width:1022px;margin:0 auto}}"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/client/components/recruitments/AvailableDates/index.tsx






var AvailableDates = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "jsx-78628dc614003791" + " " + "mx-5",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: paths/* paths.accounts.availableDates */.H.accounts.availableDates,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "jsx-78628dc614003791" + " " + "flex mx-auto available-link",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "jsx-78628dc614003791" + " " + "bg-dark-green flex icon-bg",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* CalendarIcon */.Qu, {})
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "jsx-78628dc614003791",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "jsx-78628dc614003791" + " " + "text-green font-bold text-sm mb-2",
                                    children: "働ける日を登録しましょう！"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "jsx-78628dc614003791" + " " + "text-sm text-light-black",
                                    children: "登録した日の求人通知が届きます。"
                                })
                            ]
                        })
                    ]
                })
            }),
            (0,jsx_runtime.jsx)((style_default()), {
                id: "78628dc614003791",
                children: ".available-link.jsx-78628dc614003791{max-width:335px;padding:11px 20px;border:1px solid#d8d8d8;-webkit-box-shadow:1px 1px 10px rgba(0,0,0,.1);-moz-box-shadow:1px 1px 10px rgba(0,0,0,.1);box-shadow:1px 1px 10px rgba(0,0,0,.1);-webkit-border-radius:10px;-moz-border-radius:10px;border-radius:10px;-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center}.icon-bg.jsx-78628dc614003791{width:50px;height:50px;-webkit-border-radius:50%;-moz-border-radius:50%;border-radius:50%;-webkit-box-pack:center;-webkit-justify-content:center;-moz-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;margin-right:16px}"
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/date-fns/esm/isBefore/index.js
var isBefore = __webpack_require__(313);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/isSameDay/index.js
var isSameDay = __webpack_require__(3151);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/addWeeks/index.js
var addWeeks = __webpack_require__(63500);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/differenceInCalendarDays/index.js
var differenceInCalendarDays = __webpack_require__(92300);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/locale/ja/index.js + 5 modules
var ja = __webpack_require__(40944);
// EXTERNAL MODULE: ./node_modules/swiper/esm/react/swiper-slide.js
var swiper_slide = __webpack_require__(24002);
// EXTERNAL MODULE: ./node_modules/swiper/esm/react/swiper.js + 79 modules
var swiper = __webpack_require__(16794);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/subDays/index.js
var subDays = __webpack_require__(7069);
;// CONCATENATED MODULE: ./src/utils/calendar.ts

var getCalendarStartingDate = function(currentDate) {
    // JavaScriptのgetDay は日曜が0
    if (currentDate.getDay() == 0) {
        // Ucareのカレンダーは月曜はじまりで、JavaScriptのgetDayでは補正できない
        // なので、currentDateが日曜日の場合は6日巻き戻す
        return (0,subDays/* default */.Z)(currentDate, 6);
    } else {
        // currentDateが日曜日でなければ、
        // (曜日の数字 - 1)日巻き戻す
        var daysToSub = currentDate.getDay() - 1;
        return (0,subDays/* default */.Z)(currentDate, daysToSub);
    }
};
var getDatesOfOneWeek = function(monday) {
    var result = [];
    for(var i = 0; i < 7; i++){
        var newDate = new Date(monday.getTime());
        newDate.setDate(monday.getDate() + i);
        result.push(newDate);
    }
    return result;
};

;// CONCATENATED MODULE: ./src/client/components/recruitments/Calendar/HorizontalScrollingCalendar.tsx







// 横スワイプカレンダー(曜日は月曜はじまり)
var HorizontalScrollingCalendar = function(param) {
    var currentDate = param.currentDate, initialSelectedDate = param.initialSelectedDate, onDateClicked = param.onDateClicked;
    var ref = (0,react.useState)(initialSelectedDate != null ? initialSelectedDate : new Date(currentDate.getTime())), selectedDate = ref[0], setSelectedDate = ref[1];
    var onClick = function(e) {
        var newSelectedDateText = e.currentTarget.id;
        setSelectedDate(new Date(newSelectedDateText));
        onDateClicked(newSelectedDateText);
    };
    var getClassNameOfDate = function(date, currentDate, selectedDate) {
        if ((0,isBefore/* default */.Z)(date, currentDate)) {
            return "past-day";
        } else if ((0,isSameDay/* default */.Z)(date, selectedDate)) {
            return "selected-day";
        } else {
            return "display-day";
        }
    };
    /**
   * 横スクロールカレンダーの中身を1週間ずつ1年分(54週)作成する
   * @param calendarStartingDate カレンダー生成の起算日 (現状、月曜日)
   */ var createSwiperContents = function(calendarStartingDate, currentDate, selectedDate) {
        var swiperContents = [];
        for(var week = 0; week < 54; week++){
            var mondayOfTheWeek = (0,addWeeks/* default */.Z)(calendarStartingDate, week);
            var dates = getDatesOfOneWeek(mondayOfTheWeek);
            swiperContents.push(/*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_slide/* SwiperSlide */.o, {
                className: "day-clicked",
                children: dates.map(function(date, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        type: "button",
                        className: getClassNameOfDate(date, currentDate, selectedDate),
                        id: (0,format/* default */.Z)(date, "yyyy-MM-dd"),
                        value: date.getDate(),
                        onClick: onClick,
                        disabled: (0,isBefore/* default */.Z)(date, currentDate)
                    }, index);
                })
            }, "swipeSlide".concat(week)));
        }
        return swiperContents;
    };
    var calendarStartingDate = getCalendarStartingDate(currentDate);
    var swiperContents = createSwiperContents(calendarStartingDate, currentDate, selectedDate);
    var initialSlide = initialSelectedDate != null ? Math.floor((0,differenceInCalendarDays/* default */.Z)(initialSelectedDate, calendarStartingDate) / 7) : 0;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "jsx-92381ed425afcdfe" + " " + "mt-0 mb-3.5 mx-[30px]",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "jsx-92381ed425afcdfe" + " " + "mb-5",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "jsx-92381ed425afcdfe" + " " + "mt-0 mb-2 mx-[7px] flex justify-between",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "jsx-92381ed425afcdfe" + " " + "font-xs text-center",
                                    children: "月"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "jsx-92381ed425afcdfe" + " " + "font-xs text-center",
                                    children: "火"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "jsx-92381ed425afcdfe" + " " + "font-xs text-center",
                                    children: "水"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "jsx-92381ed425afcdfe" + " " + "font-xs text-center",
                                    children: "木"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "jsx-92381ed425afcdfe" + " " + "font-xs text-center",
                                    children: "金"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "jsx-92381ed425afcdfe" + " " + "font-xs text-center text-[#5aa6e5]",
                                    children: "土"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "jsx-92381ed425afcdfe" + " " + "font-xs text-center text-red",
                                    children: "日"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper/* Swiper */.t, {
                            initialSlide: initialSlide,
                            spaceBetween: 10,
                            slidesPerView: 1,
                            children: swiperContents
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "jsx-92381ed425afcdfe" + " " + "text-center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "jsx-92381ed425afcdfe",
                        children: (0,format/* default */.Z)(selectedDate, "yyyy年M月d日(E)", {
                            locale: ja/* default */.Z
                        })
                    })
                }),
                (0,jsx_runtime.jsx)((style_default()), {
                    id: "92381ed425afcdfe",
                    children: ".past-day.jsx-92381ed425afcdfe{color:#bbb}"
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/client/components/recruitments/Calendar/index.tsx






var Calendar = function() {
    var router = (0,next_router.useRouter)();
    var ref = useRecruitmentListContext(), _searchQueryParams = ref.searchQueryParams, selectedDateText = _searchQueryParams.date, areaIds = _searchQueryParams.areaIds, licenseIds = _searchQueryParams.licenseIds, facilityFeatureIds = _searchQueryParams.facilityFeatureIds, jobBenefitIds = _searchQueryParams.jobBenefitIds, sortOptionId = _searchQueryParams.sortOptionId, maximumDailyWage = _searchQueryParams.maximumDailyWage, minimumDailyWage = _searchQueryParams.minimumDailyWage, workingHourOptionIds = _searchQueryParams.workingHourOptionIds, maximumWorkingHours = _searchQueryParams.maximumWorkingHours, jobTaskIds = _searchQueryParams.jobTaskIds, onlyRecruiting = _searchQueryParams.onlyRecruiting, currentDateText = ref.currentDateText, dispatch = ref.dispatch;
    var urlQueryParams = useUrlQueryParams({
        date: selectedDateText,
        areaIds: areaIds,
        licenseIds: licenseIds,
        facilityFeatureIds: facilityFeatureIds,
        jobBenefitIds: jobBenefitIds,
        sortOptionId: sortOptionId,
        maximumDailyWage: maximumDailyWage,
        minimumDailyWage: minimumDailyWage,
        workingHourOptionIds: workingHourOptionIds,
        maximumWorkingHours: maximumWorkingHours,
        jobTaskIds: jobTaskIds,
        onlyRecruiting: onlyRecruiting
    }).urlQueryParams;
    (0,react.useEffect)(function() {
        router.push({
            query: urlQueryParams
        }, {
            // @ts-ignore
            pathname: router.query.name,
            query: urlQueryParams
        }, {
            shallow: true
        });
    }, [
        selectedDateText
    ]);
    var dispatchChangeDateFromCalendar = function(dateText) {
        dispatch({
            type: "changeDate",
            payload: {
                date: dateText
            }
        });
    };
    var currentDate = new Date(currentDateText);
    var selectedDate = new Date(selectedDateText);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(HorizontalScrollingCalendar, {
        currentDate: currentDate,
        initialSelectedDate: selectedDate,
        onDateClicked: dispatchChangeDateFromCalendar
    });
};

// EXTERNAL MODULE: ./src/client/components/common/Modal.tsx
var Modal = __webpack_require__(84642);
;// CONCATENATED MODULE: ./src/client/components/recruitments/Modal/SearchConditionModal/index.tsx




var SearchConditionModal = function(param) {
    var areaIds = param.areaIds, conditionList = param.conditionList, _handlers = param.handlers, handleClickClear = _handlers.handleClickClear, handleClickClose = _handlers.handleClickClose;
    var onClose = canSearch({
        prefectureIds: areaIds
    }) ? handleClickClose : undefined;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* Modal */.u, {
            title: "絞り込み条件",
            onClose: onClose,
            onClear: handleClickClear,
            children: conditionList
        })
    });
};

// EXTERNAL MODULE: ./src/client/components/common/Button.tsx
var Button = __webpack_require__(41299);
;// CONCATENATED MODULE: ./src/client/components/recruitments/Modal/AreaModal/PrefecturesList.tsx







var PrefecturesList = function(param) {
    var selectedRegion = param.selectedRegion, areaTreeData = param.areaTreeData;
    var ref;
    var ref1 = useRecruitmentListContext(), _searchQueryParams = ref1.searchQueryParams, date = _searchQueryParams.date, areaIds = _searchQueryParams.areaIds, licenseIds = _searchQueryParams.licenseIds, facilityFeatureIds = _searchQueryParams.facilityFeatureIds, jobBenefitIds = _searchQueryParams.jobBenefitIds, sortOptionId = _searchQueryParams.sortOptionId, workingHourOptionIds = _searchQueryParams.workingHourOptionIds, maximumWorkingHours = _searchQueryParams.maximumWorkingHours, maximumDailyWage = _searchQueryParams.maximumDailyWage, minimumDailyWage = _searchQueryParams.minimumDailyWage, jobTaskIds = _searchQueryParams.jobTaskIds, onlyRecruiting = _searchQueryParams.onlyRecruiting, modeHistory = ref1.ui.modeHistory, dispatch = ref1.dispatch;
    var router = (0,next_router.useRouter)();
    var urlQueryParams = useUrlQueryParams({
        date: date,
        areaIds: areaIds,
        licenseIds: licenseIds,
        facilityFeatureIds: facilityFeatureIds,
        jobBenefitIds: jobBenefitIds,
        sortOptionId: sortOptionId,
        maximumDailyWage: maximumDailyWage,
        minimumDailyWage: minimumDailyWage,
        workingHourOptionIds: workingHourOptionIds,
        maximumWorkingHours: maximumWorkingHours,
        jobTaskIds: jobTaskIds,
        onlyRecruiting: onlyRecruiting
    }).urlQueryParams;
    var lastMode = modeHistory[modeHistory.length - 2];
    var regionSelectedValue = (0,react.useMemo)(function() {
        return areaTreeData === null || areaTreeData === void 0 ? void 0 : areaTreeData.areaTree.regions.filter(function(o) {
            return selectedRegion.includes(o.id);
        }).map(function(o) {
            return o.areaLList;
        });
    }, [
        selectedRegion,
        areaTreeData
    ]);
    var handleClickCheckbox = (0,react.useCallback)(function(id) {
        var newSelectedAreaIds = areaIds ? Array.from(areaIds) : [];
        if (areaIds === null || areaIds === void 0 ? void 0 : areaIds.includes(id)) {
            newSelectedAreaIds = newSelectedAreaIds.filter(function(areaId) {
                return areaId !== id;
            });
        } else {
            newSelectedAreaIds.push(id);
        }
        dispatch({
            type: "changeAreaIds",
            payload: {
                areaIds: newSelectedAreaIds
            }
        });
    }, [
        areaIds
    ]);
    var isChecked = function(id) {
        return (areaIds === null || areaIds === void 0 ? void 0 : areaIds.includes(id)) || false;
    };
    var handleSearchClick = function() {
        router.push({
            query: urlQueryParams
        }, {
            // @ts-ignore
            pathname: router.query.name,
            query: urlQueryParams
        }, {
            shallow: true
        });
        handleClickClose();
    };
    var handleClickClose = function() {
        dispatch({
            type: "changeDisplayMode",
            payload: {
                displayMode: lastMode
            }
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mx-4",
                children: regionSelectedValue && ((ref = regionSelectedValue[0]) === null || ref === void 0 ? void 0 : ref.map(function(prefecture) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-full inline-flex items-center justify-between pt-5 pb-4 border-b border-light-gray",
                        onClick: function() {
                            return handleClickCheckbox(prefecture.id);
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox, {
                            label: prefecture.name,
                            checked: isChecked(prefecture.id),
                            onClick: function() {}
                        })
                    }, prefecture.id);
                }))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "w-full fixed bottom-0 text-center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-full border border-light-gray"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                        text: "決定",
                        onClick: handleSearchClick,
                        active: !!(areaIds === null || areaIds === void 0 ? void 0 : areaIds.length),
                        disabled: !(areaIds === null || areaIds === void 0 ? void 0 : areaIds.length)
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/client/components/recruitments/Modal/AreaModal/RegionList.tsx


var RegionList = function(param) {
    var areaTreeData = param.areaTreeData, setSelectedRegion = param.setSelectedRegion, setAreaModalUI = param.setAreaModalUI;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "mx-4",
            children: areaTreeData === null || areaTreeData === void 0 ? void 0 : areaTreeData.areaTree.regions.map(function(o) {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "w-full inline-flex items-center justify-between pt-5 pb-4 border-b border-light-gray",
                    id: o.id,
                    onClick: function(e) {
                        setSelectedRegion(e.currentTarget.id);
                        setAreaModalUI("prefectures");
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: o.name
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* ArrowForwardIcon */.mr, {
                            width: 18
                        })
                    ]
                }, o.id);
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/client/components/recruitments/Modal/AreaModal/index.tsx





var AreaModal = function(param) {
    var areaTreeData = param.areaTreeData, areaIds = param.areaIds, _handlers = param.handlers, handleClickClear = _handlers.handleClickClear, handleClickClose = _handlers.handleClickClose;
    // モーダル変更用
    var ref = (0,react.useState)("region"), areaModalUI = ref[0], setAreaModalUI = ref[1];
    // モーダル遷移用の状態管理
    var ref1 = (0,react.useState)(""), selectedRegion = ref1[0], setSelectedRegion = ref1[1];
    var regions = areaTreeData === null || areaTreeData === void 0 ? void 0 : areaTreeData.areaTree.regions;
    var closeClick = function() {
        handleClickClose();
        setSelectedRegion("");
    };
    (0,react.useEffect)(function() {
        // もしエリアツリーで地方が1つの場合、都道府県選択に自動遷移
        if ((regions === null || regions === void 0 ? void 0 : regions.length) == 1) {
            setSelectedRegion(regions[0].id);
            setAreaModalUI("prefectures");
        }
    }, [
        regions
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* Modal */.u, {
        title: "エリア",
        onClose: (areaIds === null || areaIds === void 0 ? void 0 : areaIds.length) ? closeClick : undefined,
        onClear: areaModalUI === "region" ? null : handleClickClear,
        dataTestId: "region-and-prefecture-modal",
        children: [
            areaModalUI === "region" && (regions === null || regions === void 0 ? void 0 : regions.length) !== 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(RegionList, {
                areaTreeData: areaTreeData,
                setSelectedRegion: setSelectedRegion,
                setAreaModalUI: setAreaModalUI
            }),
            areaModalUI === "prefectures" && /*#__PURE__*/ (0,jsx_runtime.jsx)(PrefecturesList, {
                selectedRegion: selectedRegion,
                areaTreeData: areaTreeData
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/client/components/recruitments/Modal/LicenseModal/index.tsx



var LicenseModal = function(param) {
    var licenseList = param.licenseList, _handlers = param.handlers, handleClickClear = _handlers.handleClickClear, handleClickClose = _handlers.handleClickClose;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* Modal */.u, {
                title: "応募に必要な資格",
                onClose: handleClickClose,
                onClear: handleClickClear,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "my-4 mx-5 font-bold",
                        children: licenseList
                    })
                })
            }),
            ");"
        ]
    });
};

;// CONCATENATED MODULE: ./src/client/components/recruitments/Modal/JobBenefitModal/index.tsx



var JobBenefitModal = function(param) {
    var jobBenefitList = param.jobBenefitList, _handlers = param.handlers, handleClickClear = _handlers.handleClickClear, handleClickClose = _handlers.handleClickClose;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        "data-testid": "border-b border-solid border-gray my-0 mx-5",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* Modal */.u, {
            title: "求人の特徴",
            onClose: handleClickClose,
            onClear: handleClickClear,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "text-base font-bold text-left mx-5 my-[17px] text-black",
                    children: jobBenefitList
                })
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/client/components/recruitments/Modal/WorkingHourOptionModal/index.tsx



var WorkingHourOptionModal = function(param) {
    var workingHourOptionList = param.workingHourOptionList, _handlers = param.handlers, handleClickClear = _handlers.handleClickClear, handleClickClose = _handlers.handleClickClose;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* Modal */.u, {
                title: "時間帯",
                onClose: handleClickClose,
                onClear: handleClickClear,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "my-4 mx-5 font-bold",
                        children: workingHourOptionList
                    })
                })
            }),
            ");"
        ]
    });
};

;// CONCATENATED MODULE: ./src/client/components/recruitments/Modal/JobBenefitModal/JobBenefitList.tsx




var JobBenefitList = function(param) {
    var jobBenefits = param.jobBenefits;
    var ref = useRecruitmentListContext(), jobBenefitIds = ref.searchQueryParams.jobBenefitIds, dispatch = ref.dispatch;
    var handleClickCheckbox = (0,react.useCallback)(function(id) {
        var newJobBenefitIds = jobBenefitIds ? Array.from(jobBenefitIds) : [];
        if (jobBenefitIds === null || jobBenefitIds === void 0 ? void 0 : jobBenefitIds.includes(id)) {
            newJobBenefitIds = newJobBenefitIds.filter(function(areaId) {
                return areaId !== id;
            });
        } else {
            newJobBenefitIds.push(id);
        }
        dispatch({
            type: "changeJobBenefitIds",
            payload: {
                jobBenefitIds: newJobBenefitIds
            }
        });
    }, [
        jobBenefitIds
    ]);
    var isChecked = function(id) {
        return (jobBenefitIds === null || jobBenefitIds === void 0 ? void 0 : jobBenefitIds.includes(id)) || false;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "py-6 px-0",
        children: jobBenefits.length > 0 && jobBenefits.map(function(benefit) {
            return benefit && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "w-full inline-flex items-center justify-between pt-5 pb-4 border-b border-light-gray",
                onClick: function() {
                    return handleClickCheckbox(benefit.id);
                },
                "data-testid": "job-benefit-checkbox-".concat(benefit.id),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox, {
                        label: benefit.name,
                        checked: isChecked(benefit.id),
                        onClick: function() {}
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "divider"
                    })
                ]
            }, benefit.id);
        })
    });
};

;// CONCATENATED MODULE: ./src/client/components/recruitments/Modal/WorkingHourOptionModal/WorkingHourOptionList.tsx




var WorkingHourOptionList = function(param) {
    var workingHourOptions = param.workingHourOptions;
    var ref = useRecruitmentListContext(), workingHourOptionIds = ref.searchQueryParams.workingHourOptionIds, dispatch = ref.dispatch;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "mx-0 my-6",
        children: workingHourOptions.length > 0 && workingHourOptions.map(function(option) {
            return option && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "w-full inline-flex items-center justify-between pt-5 pb-4 border-b border-light-gray",
                onClick: function() {
                    return dispatch({
                        type: "changeWorkingHourOptionIds",
                        payload: {
                            workingHourOptionId: option.id
                        }
                    });
                },
                "data-testid": "working-hour-option-checkbox-".concat(option.id),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox, {
                        label: option.name,
                        checked: (workingHourOptionIds === null || workingHourOptionIds === void 0 ? void 0 : workingHourOptionIds.includes(option.id)) || false,
                        onClick: function() {}
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "divider"
                    })
                ]
            }, option.id);
        })
    });
};

;// CONCATENATED MODULE: ./src/client/components/recruitments/Modal/LicenseModal/LicenseList.tsx




var LicenseList = function(param) {
    var licenses = param.licenses;
    var ref = useRecruitmentListContext(), licenseIds = ref.searchQueryParams.licenseIds, dispatch = ref.dispatch;
    var handleClickCheckbox = (0,react.useCallback)(function(id) {
        var newLicenseIds = licenseIds ? Array.from(licenseIds) : [];
        if (licenseIds === null || licenseIds === void 0 ? void 0 : licenseIds.includes(id)) {
            newLicenseIds = newLicenseIds.filter(function(areaId) {
                return areaId !== id;
            });
        } else {
            newLicenseIds.push(id);
        }
        dispatch({
            type: "changeLicenseIds",
            payload: {
                licenseIds: newLicenseIds
            }
        });
    }, [
        licenseIds
    ]);
    var isChecked = function(id) {
        return (licenseIds === null || licenseIds === void 0 ? void 0 : licenseIds.includes(id)) || false;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "my-6 mx-0",
        children: licenses.length > 0 && licenses.map(function(license) {
            return license && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "w-full inline-flex items-center justify-between pt-5 pb-4 border-b border-light-gray",
                onClick: function() {
                    return handleClickCheckbox(license.id);
                },
                "data-testid": "license-checkbox-".concat(license.id),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox, {
                        label: license.name,
                        checked: isChecked(license.id),
                        onClick: function() {}
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "divider"
                    })
                ]
            }, license.id);
        })
    });
};

;// CONCATENATED MODULE: ./src/client/components/recruitments/Modal/SearchConditionModal/ModalInput.tsx



var trimString = function(value) {
    var text = typeof value === "string" ? value : (value === null || value === void 0 ? void 0 : value.join(", ")) || "";
    return text.length > 14 ? "".concat(text.substr(0, 14), " ...") : text;
};
var ModalInput = function(param) {
    var title = param.title, value = param.value, onClick = param.onClick, arrowIcon = param.arrowIcon, dataTestId = param.dataTestId;
    var selectedValueText = (0,react.useMemo)(function() {
        return trimString(value);
    }, [
        value
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "w-full inline-flex items-center justify-between pt-5 pb-4 border-b border-light-gray",
            "data-testid": dataTestId,
            onClick: onClick,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "text-sm font-normal text-black",
                    children: title
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "inline-flex items-center justify-between gap-4",
                    children: [
                        value && value.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: selectedValueText
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "text-font-gray",
                            children: "選択なし"
                        }),
                        arrowIcon ? /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* ArrowForwardIcon */.mr, {
                            width: 18
                        }) : null
                    ]
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/client/components/recruitments/Modal/SearchConditionModal/DailyWageInput.tsx




var DailyWageInput = function(param) {
    var title = param.title, maxDailyWage = param.maxDailyWage, minDailyWage = param.minDailyWage;
    var maxDailyWageValueWithComma = (0,react.useMemo)(function() {
        return maxDailyWage ? maxDailyWage.toLocaleString("ja") : "";
    }, [
        maxDailyWage
    ]);
    var minDailyWageValueWithComma = (0,react.useMemo)(function() {
        return minDailyWage ? minDailyWage.toLocaleString("ja") : "";
    }, [
        minDailyWage
    ]);
    var ref = (0,react.useState)(maxDailyWageValueWithComma), maxDailyWageValue = ref[0], setMaxDailyWageValue = ref[1];
    var ref1 = (0,react.useState)(minDailyWageValueWithComma), minDailyWageValue = ref1[0], setMinDailyWageValue = ref1[1];
    var dispatch = useRecruitmentListContext().dispatch;
    var onChangeMaxDailyWage = function(s) {
        setMaxDailyWageValue(s);
        dispatch({
            type: "changeMaximumDailyWage",
            payload: {
                maximumDailyWage: s === "" ? null : Number(s)
            }
        });
    };
    var onChangeMinDailyWage = function(s) {
        setMinDailyWageValue(s);
        dispatch({
            type: "changeMinimumDailyWage",
            payload: {
                minimumDailyWage: s === "" ? null : Number(s)
            }
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "jsx-bdcc74b036da5c97" + " " + "w-full inline-flex items-center justify-between pt-5 pb-4 border-b border-light-gray",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "jsx-bdcc74b036da5c97" + " " + "text-sm font-normal text-black",
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "jsx-bdcc74b036da5c97" + " " + "input-wrapper",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                type: "text",
                                placeholder: "下限",
                                value: minDailyWageValue,
                                onBlur: function() {
                                    setMinDailyWageValue(minDailyWageValueWithComma);
                                },
                                onFocus: function() {
                                    setMinDailyWageValue(minDailyWage ? minDailyWage + "" : "");
                                },
                                onChange: function(e) {
                                    onChangeMinDailyWage(e.target.value);
                                },
                                className: "jsx-bdcc74b036da5c97"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "jsx-bdcc74b036da5c97" + " " + "tilde",
                                children: "~"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                type: "text",
                                placeholder: "上限",
                                value: maxDailyWageValue,
                                onBlur: function() {
                                    setMaxDailyWageValue(maxDailyWageValueWithComma);
                                },
                                onFocus: function() {
                                    setMaxDailyWageValue(maxDailyWage ? maxDailyWage + "" : "");
                                },
                                onChange: function(e) {
                                    onChangeMaxDailyWage(e.target.value);
                                },
                                className: "jsx-bdcc74b036da5c97"
                            })
                        ]
                    })
                ]
            }),
            (0,jsx_runtime.jsx)((style_default()), {
                id: "bdcc74b036da5c97",
                children: '.tilde.jsx-bdcc74b036da5c97{margin:0 20px}input.jsx-bdcc74b036da5c97{width:4.5rem;outline:none;font-family:"Hiragino Sans";font-style:normal;font-weight:400;font-size:14px;line-height:21px;text-align:center;color:#4d5253}.input-wrapper.jsx-bdcc74b036da5c97{display:-webkit-inline-box;display:-webkit-inline-flex;display:-moz-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:justify;-webkit-justify-content:space-between;-moz-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}'
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/client/components/recruitments/Modal/SearchConditionModal/WorkingHoursInput.tsx


var WorkingHoursInput = function(param) {
    var title = param.title, value = param.value, onChange = param.onChange;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                className: "jsx-e8f4f0b027f32e54" + " " + "w-full inline-flex items-center justify-between pt-5 pb-4 border-b border-light-gray",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "jsx-e8f4f0b027f32e54" + " " + "text-sm font-normal text-black",
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "jsx-e8f4f0b027f32e54" + " " + "select-input-wrapper",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                type: "number",
                                placeholder: "時間を入力",
                                min: 0,
                                value: value + "",
                                onChange: function(e) {
                                    onChange(e.target.value === "" ? null : Number(e.target.value));
                                },
                                className: "jsx-e8f4f0b027f32e54" + " " + "select-input-working-hours text-sm px-1 mr-2"
                            }),
                            "時間以内"
                        ]
                    })
                ]
            }),
            (0,jsx_runtime.jsx)((style_default()), {
                id: "e8f4f0b027f32e54",
                children: ".select-input-working-hours.jsx-e8f4f0b027f32e54{max-width:100px;-moz-appearance:textfield}.select-input-working-hours.jsx-e8f4f0b027f32e54::-webkit-outer-spin-button,.select-input-working-hours.jsx-e8f4f0b027f32e54::-webkit-inner-spin-button{-webkit-appearance:none;margin:0}.select-input-wrapper.jsx-e8f4f0b027f32e54{display:-webkit-inline-box;display:-webkit-inline-flex;display:-moz-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:justify;-webkit-justify-content:space-between;-moz-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/client/components/recruitments/Modal/SearchConditionModal/OnlyRecruitingCheckbox.tsx




var OnlyRecruitingCheckbox = function() {
    var ref = useRecruitmentListContext(), onlyRecruiting = ref.searchQueryParams.onlyRecruiting, dispatch = ref.dispatch;
    var handleClickCheckbox = (0,react.useCallback)(function() {
        dispatch({
            type: "changeOnlyRecruiting",
            payload: {
                onlyRecruiting: !onlyRecruiting
            }
        });
    }, [
        onlyRecruiting
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "w-full inline-flex items-center justify-between pt-5 pb-4 border-b border-light-gray",
        onClick: function() {
            return handleClickCheckbox();
        },
        "data-testid": "recruitment-state-checkbox",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox, {
                label: "募集中の求人のみ表示する",
                checked: !!onlyRecruiting,
                onClick: function() {}
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "divider"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/client/components/recruitments/Modal/SearchConditionModal/ConditionsList.tsx










var ConditionsList = function(param) {
    var licenses = param.licenses, facilityFeatures = param.facilityFeatures, regions = param.regions, workingHourOptions = param.workingHourOptions, jobBenefits = param.jobBenefits, jobTasks = param.jobTasks;
    var router = (0,next_router.useRouter)();
    var ref = useRecruitmentListContext(), _searchQueryParams = ref.searchQueryParams, date = _searchQueryParams.date, areaIds = _searchQueryParams.areaIds, licenseIds = _searchQueryParams.licenseIds, facilityFeatureIds = _searchQueryParams.facilityFeatureIds, jobBenefitIds = _searchQueryParams.jobBenefitIds, sortOptionId = _searchQueryParams.sortOptionId, workingHourOptionIds = _searchQueryParams.workingHourOptionIds, maximumWorkingHours = _searchQueryParams.maximumWorkingHours, maximumDailyWage = _searchQueryParams.maximumDailyWage, minimumDailyWage = _searchQueryParams.minimumDailyWage, jobTaskIds = _searchQueryParams.jobTaskIds, onlyRecruiting = _searchQueryParams.onlyRecruiting, dispatch = ref.dispatch;
    var urlQueryParams = useUrlQueryParams({
        date: date,
        areaIds: areaIds,
        licenseIds: licenseIds,
        facilityFeatureIds: facilityFeatureIds,
        jobBenefitIds: jobBenefitIds,
        sortOptionId: sortOptionId,
        maximumDailyWage: maximumDailyWage,
        minimumDailyWage: minimumDailyWage,
        workingHourOptionIds: workingHourOptionIds,
        maximumWorkingHours: maximumWorkingHours,
        jobTaskIds: jobTaskIds,
        onlyRecruiting: onlyRecruiting
    }).urlQueryParams;
    var licenseIdsSelectedValue = (0,react.useMemo)(function() {
        return licenses.filter(function(o) {
            return licenseIds === null || licenseIds === void 0 ? void 0 : licenseIds.includes(o.id);
        }).map(function(o) {
            return o.name;
        });
    }, [
        licenseIds,
        licenses
    ]);
    var facilityFeaturesSelectedValue = (0,react.useMemo)(function() {
        return facilityFeatures.filter(function(o) {
            return facilityFeatureIds === null || facilityFeatureIds === void 0 ? void 0 : facilityFeatureIds.includes(o.id);
        }).map(function(o) {
            return o.name;
        });
    }, [
        facilityFeatureIds,
        facilityFeatures
    ]);
    var areaIdsSelectedValue = (0,react.useMemo)(function() {
        var selectedArray = [];
        regions.map(function(o) {
            return o.areaLList.map(function(x) {
                if (areaIds === null || areaIds === void 0 ? void 0 : areaIds.includes(x.id)) {
                    selectedArray.push(x.name);
                }
            });
        });
        return selectedArray;
    }, [
        areaIds,
        regions
    ]);
    var jobBenefitsSelectedValue = (0,react.useMemo)(function() {
        return jobBenefits.filter(function(j) {
            return jobBenefitIds === null || jobBenefitIds === void 0 ? void 0 : jobBenefitIds.includes(j.id);
        }).map(function(j) {
            return j.name;
        });
    }, [
        jobBenefitIds,
        jobBenefits
    ]);
    var jobTasksSelectedValue = (0,react.useMemo)(function() {
        return jobTasks.filter(function(j) {
            return jobTaskIds === null || jobTaskIds === void 0 ? void 0 : jobTaskIds.includes(j.id);
        }).map(function(j) {
            return j.name;
        });
    }, [
        jobTaskIds,
        jobTasks
    ]);
    var workingHourOptionIdSelectedValue = (0,react.useMemo)(function() {
        return workingHourOptions.filter(function(w) {
            return workingHourOptionIds === null || workingHourOptionIds === void 0 ? void 0 : workingHourOptionIds.includes(w.id);
        }).map(function(w) {
            return w.name;
        });
    }, [
        workingHourOptionIds,
        workingHourOptions
    ]);
    var handleClickAreaSelect = function() {
        dispatch({
            type: "changeDisplayMode",
            payload: {
                displayMode: "area-modal"
            }
        });
    };
    var handleClickLicenseSelect = function() {
        dispatch({
            type: "changeDisplayMode",
            payload: {
                displayMode: "license-modal"
            }
        });
    };
    var handleClickFacilityFeature = function() {
        dispatch({
            type: "changeDisplayMode",
            payload: {
                displayMode: "facility-feature-modal"
            }
        });
    };
    var handleClickWorkingHourOptionSelect = function() {
        dispatch({
            type: "changeDisplayMode",
            payload: {
                displayMode: "working-hour-option-modal"
            }
        });
    };
    var handleClickJobBenefitSelect = function() {
        dispatch({
            type: "changeDisplayMode",
            payload: {
                displayMode: "job-benefit-modal"
            }
        });
    };
    var handleClickJobTaskSelect = function() {
        dispatch({
            type: "changeDisplayMode",
            payload: {
                displayMode: "job-task-modal"
            }
        });
    };
    var handleClickSearch = function() {
        router.push({
            query: urlQueryParams
        }, {
            // @ts-ignore
            pathname: router.query.name,
            query: urlQueryParams
        }, {
            shallow: true
        });
        handleClickClose();
    };
    var handleClickClose = function() {
        dispatch({
            type: "changeDisplayMode",
            payload: {
                displayMode: "list"
            }
        });
    };
    var handleChangeMaximumWorkingHours = function(hours) {
        dispatch({
            type: "changeMaximumWorkingHours",
            payload: {
                maximumWorkingHours: hours
            }
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mx-4",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalInput, {
                        title: "エリア",
                        value: areaIdsSelectedValue,
                        onClick: handleClickAreaSelect,
                        arrowIcon: true,
                        dataTestId: "search-condition-area"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalInput, {
                        title: "応募に必要な資格",
                        value: licenseIdsSelectedValue,
                        onClick: handleClickLicenseSelect,
                        arrowIcon: true,
                        dataTestId: "search-condition-license"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalInput, {
                        title: "サービス種別",
                        value: facilityFeaturesSelectedValue,
                        onClick: handleClickFacilityFeature,
                        arrowIcon: true,
                        dataTestId: "search-condition-facility-feature"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalInput, {
                        title: "時間帯",
                        value: workingHourOptionIdSelectedValue,
                        onClick: handleClickWorkingHourOptionSelect,
                        arrowIcon: true,
                        dataTestId: "search-condition-working-hour-option"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DailyWageInput, {
                        title: "日給",
                        maxDailyWage: maximumDailyWage !== null && maximumDailyWage !== void 0 ? maximumDailyWage : undefined,
                        minDailyWage: minimumDailyWage !== null && minimumDailyWage !== void 0 ? minimumDailyWage : undefined
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(WorkingHoursInput, {
                        title: "労働時間",
                        onChange: handleChangeMaximumWorkingHours,
                        value: maximumWorkingHours
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalInput, {
                        title: "求人の特徴",
                        value: jobBenefitsSelectedValue,
                        onClick: handleClickJobBenefitSelect,
                        arrowIcon: true,
                        dataTestId: "search-condition-job-benefit"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalInput, {
                        title: "仕事内容",
                        value: jobTasksSelectedValue,
                        onClick: handleClickJobTaskSelect,
                        arrowIcon: true,
                        dataTestId: "search-condition-job-task"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(OnlyRecruitingCheckbox, {}),
                    !(areaIds === null || areaIds === void 0 ? void 0 : areaIds.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mt-2",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "text-xs text-red font-bold",
                            children: "エリアを選択してください"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "modal-submit",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "fixed bottom-0 w-full text-center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "w-full border-b border-solid border-gray"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                            text: "検索する",
                            onClick: handleClickSearch,
                            active: !!(areaIds === null || areaIds === void 0 ? void 0 : areaIds.length),
                            disabled: !(areaIds === null || areaIds === void 0 ? void 0 : areaIds.length)
                        })
                    ]
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/client/components/recruitments/Modal/JobTaskModal/index.tsx



var JobTaskModal = function(param) {
    var jobTaskList = param.jobTaskList, _handlers = param.handlers, handleClickClear = _handlers.handleClickClear, handleClickClose = _handlers.handleClickClose;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        "data-testid": "test-modal",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* Modal */.u, {
                title: "仕事内容",
                onClose: handleClickClose,
                onClear: handleClickClear,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "my-4 mx-5 font-bold",
                        children: jobTaskList
                    })
                })
            }),
            ");"
        ]
    });
};

;// CONCATENATED MODULE: ./src/client/components/recruitments/Modal/JobTaskModal/JobTaskList.tsx




var JobTaskList = function(param) {
    var jobTasks = param.jobTasks;
    var ref = useRecruitmentListContext(), jobTaskIds = ref.searchQueryParams.jobTaskIds, dispatch = ref.dispatch;
    var handleClickCheckbox = (0,react.useCallback)(function(id) {
        var newJobTaskIds = jobTaskIds ? Array.from(jobTaskIds) : [];
        if (jobTaskIds === null || jobTaskIds === void 0 ? void 0 : jobTaskIds.includes(id)) {
            newJobTaskIds = newJobTaskIds.filter(function(taskId) {
                return taskId !== id;
            });
        } else {
            newJobTaskIds.push(id);
        }
        dispatch({
            type: "changeJobTaskIds",
            payload: {
                jobTaskIds: newJobTaskIds
            }
        });
    }, [
        jobTaskIds
    ]);
    var isChecked = function(id) {
        return (jobTaskIds === null || jobTaskIds === void 0 ? void 0 : jobTaskIds.includes(id)) || false;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "my-6 mx-0",
        children: jobTasks.length > 0 && jobTasks.map(function(task) {
            return task && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "w-full inline-flex items-center justify-between pt-5 pb-4 border-b border-light-gray",
                onClick: function() {
                    return handleClickCheckbox(task.id);
                },
                "data-testid": "job-task-checkbox-".concat(task.id),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox, {
                        label: task.name,
                        checked: isChecked(task.id),
                        onClick: function() {}
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "divider"
                    })
                ]
            }, task.id);
        })
    });
};

;// CONCATENATED MODULE: ./src/client/components/recruitments/Modal/SortSettingModal/Option.tsx



var Option = function(param) {
    var name = param.name, onClick = param.onClick, isCheckVisible = param.isCheckVisible, comment = param.comment;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        onClick: onClick,
        className: " border-b border-gray3 py-4",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex justify-between",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "font-bold ".concat(comment ? "text-gray3 text-opacity-60" : "text-light-gray3"),
                        children: name
                    }),
                    isCheckVisible && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* CheckLightGreenIcon */.j2, {
                            width: 18
                        })
                    })
                ]
            }),
            comment && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "text-xs text-green mt-2",
                children: comment
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/client/components/recruitments/Modal/SortSettingModal/index.tsx









var SortSettingModal = function(param) {
    var sortOptions = param.sortOptions;
    var router = (0,next_router.useRouter)();
    var ref = useRecruitmentListContext(), _searchQueryParams = ref.searchQueryParams, selectedDateText = _searchQueryParams.date, areaIds = _searchQueryParams.areaIds, licenseIds = _searchQueryParams.licenseIds, facilityFeatureIds = _searchQueryParams.facilityFeatureIds, jobBenefitIds = _searchQueryParams.jobBenefitIds, sortOptionId = _searchQueryParams.sortOptionId, maximumDailyWage = _searchQueryParams.maximumDailyWage, minimumDailyWage = _searchQueryParams.minimumDailyWage, workingHourOptionIds = _searchQueryParams.workingHourOptionIds, maximumWorkingHours = _searchQueryParams.maximumWorkingHours, jobTaskIds = _searchQueryParams.jobTaskIds, onlyRecruiting = _searchQueryParams.onlyRecruiting, dispatch = ref.dispatch;
    var closeModal = function() {
        dispatch({
            type: "changeDisplayMode",
            payload: {
                displayMode: "list"
            }
        });
    };
    var clearSortOption = function() {
        dispatch({
            type: "clearSortOptionId"
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* Modal */.u, {
        title: "並び替え",
        onClose: closeModal,
        onClear: clearSortOption,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "mx-5",
            children: sortOptions.map(function(option) {
                var ref;
                /*#__PURE__*/ return (0,jsx_runtime.jsx)(Option, {
                    name: option.name,
                    comment: (ref = option.howToEnable) === null || ref === void 0 ? void 0 : ref.message,
                    onClick: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                        var ref, urlQueryParams;
                        return (0,tslib_es6.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    if ((ref = option.howToEnable) === null || ref === void 0 ? void 0 : ref.message) return [
                                        2
                                    ];
                                    // shallow routingなのでrouter.pushしても状態は更新されないので事前に実施
                                    dispatch({
                                        type: "selectSortOptionId",
                                        payload: {
                                            sortOptionId: option.id
                                        }
                                    });
                                    urlQueryParams = useUrlQueryParams({
                                        date: selectedDateText,
                                        areaIds: areaIds,
                                        licenseIds: licenseIds,
                                        facilityFeatureIds: facilityFeatureIds,
                                        jobBenefitIds: jobBenefitIds,
                                        sortOptionId: sortOptionId,
                                        maximumDailyWage: maximumDailyWage,
                                        minimumDailyWage: minimumDailyWage,
                                        workingHourOptionIds: workingHourOptionIds,
                                        maximumWorkingHours: maximumWorkingHours,
                                        jobTaskIds: jobTaskIds,
                                        onlyRecruiting: onlyRecruiting
                                    }).urlQueryParams;
                                    return [
                                        4,
                                        router.push({
                                            query: urlQueryParams
                                        }, {
                                            // @ts-ignore
                                            pathname: router.query.name,
                                            query: urlQueryParams
                                        }, {
                                            shallow: true
                                        })
                                    ];
                                case 1:
                                    _state.sent();
                                    closeModal();
                                    return [
                                        2
                                    ];
                            }
                        });
                    }),
                    isCheckVisible: sortOptionId === option.id
                }, option.id);
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/client/components/recruitments/Modal/FacilityFeatureListModal/FacilityFeatureList.tsx




var FacilityFeatureList = function(param) {
    var facilityFeatures = param.facilityFeatures;
    var ref = useRecruitmentListContext(), facilityFeatureIds = ref.searchQueryParams.facilityFeatureIds, dispatch = ref.dispatch;
    var handleClickCheckbox = (0,react.useCallback)(function(id) {
        var newFacilityFeatureIds = facilityFeatureIds ? Array.from(facilityFeatureIds) : [];
        if (facilityFeatureIds === null || facilityFeatureIds === void 0 ? void 0 : facilityFeatureIds.includes(id)) {
            newFacilityFeatureIds = newFacilityFeatureIds.filter(function(featureId) {
                return featureId !== id;
            });
        } else {
            newFacilityFeatureIds.push(id);
        }
        dispatch({
            type: "selectFacilityFeatureIds",
            payload: {
                facilityFeatureIds: newFacilityFeatureIds
            }
        });
    }, [
        facilityFeatureIds
    ]);
    var isChecked = function(id) {
        return (facilityFeatureIds === null || facilityFeatureIds === void 0 ? void 0 : facilityFeatureIds.includes(id)) || false;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "mx-0 my-6",
        children: facilityFeatures.length > 0 && facilityFeatures.map(function(feature) {
            return feature && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "w-full inline-flex items-center justify-between pt-5 pb-4 border-b border-light-gray",
                onClick: function() {
                    return handleClickCheckbox(feature.id);
                },
                "data-testid": "facility-feature-checkbox-".concat(feature.id),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox, {
                        label: feature.name,
                        checked: isChecked(feature.id),
                        onClick: function() {}
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "divider"
                    })
                ]
            }, feature.id);
        })
    });
};

;// CONCATENATED MODULE: ./src/client/components/recruitments/Modal/FacilityFeatureListModal/index.tsx



var FacilityFeatureListModal = function(param) {
    var facilityFeatureList = param.facilityFeatureList, _handlers = param.handlers, handleClickClear = _handlers.handleClickClear, handleClickClose = _handlers.handleClickClose;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* Modal */.u, {
            title: "サービス種別",
            onClose: handleClickClose,
            onClear: handleClickClear,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-base font-bold text-left mx-5 my-[17px] text-black",
                children: facilityFeatureList
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/client/components/recruitments/Modal/index.tsx


















var SearchModal = function() {
    var ref = (0,generated/* useJobBenefitListQuery */.bzy)({
        fetchPolicy: "cache-first"
    }), jobBenefitsData = ref.data;
    var ref1 = (0,generated/* useWorkingHourOptionListQuery */.xdA)({
        fetchPolicy: "cache-first"
    }), workingHourOptionsData = ref1.data;
    var ref2 = (0,generated/* useLicenseListQuery */.yoD)({
        fetchPolicy: "cache-first"
    }), licenseListData = ref2.data;
    var ref3 = (0,generated/* useAreaTreeQuery */.aDY)({
        fetchPolicy: "cache-first"
    }), areaListData = ref3.data;
    var ref4 = (0,generated/* useJobTaskListQuery */.WKY)({
        fetchPolicy: "cache-first"
    }), jobTasksData = ref4.data;
    var ref5 = (0,generated/* useSortOptionListQuery */.Ulk)({
        fetchPolicy: "cache-first"
    }), sortOptionsData = ref5.data;
    var ref6 = (0,generated/* useFacilityFeatureListQuery */.dn_)({
        fetchPolicy: "cache-first"
    }), facilityFeatureListData = ref6.data;
    var ref7 = useRecruitmentListContext(), areaIds = ref7.searchQueryParams.areaIds, _ui = ref7.ui, displayMode = _ui.displayMode, modeHistory = _ui.modeHistory, dispatch = ref7.dispatch;
    var lastMode = modeHistory[modeHistory.length - 2];
    var handleClickClose = function() {
        dispatch({
            type: "changeDisplayMode",
            payload: {
                displayMode: lastMode
            }
        });
    };
    var jobBenefitClickHandlers = {
        handleClickClose: handleClickClose,
        handleClickClear: function() {
            dispatch({
                type: "changeJobBenefitIds",
                payload: {
                    jobBenefitIds: []
                }
            });
        }
    };
    var workingHourOptionClickHandlers = {
        handleClickClose: handleClickClose,
        handleClickClear: function() {
            dispatch({
                type: "clearWorkingHourOptionIds"
            });
        }
    };
    var licenseClickHandlers = {
        handleClickClose: handleClickClose,
        handleClickClear: function() {
            dispatch({
                type: "changeLicenseIds",
                payload: {
                    licenseIds: []
                }
            });
        }
    };
    var facilityFeatureClickHandlers = {
        handleClickClose: handleClickClose,
        handleClickClear: function() {
            dispatch({
                type: "selectFacilityFeatureIds",
                payload: {
                    facilityFeatureIds: []
                }
            });
        }
    };
    var searchConditionClickHandlers = {
        handleClickClear: function() {
            dispatch({
                type: "resetSearchQueryParams"
            });
        },
        handleClickClose: function() {
            dispatch({
                type: "changeDisplayMode",
                payload: {
                    displayMode: "list"
                }
            });
        }
    };
    var areaClickHandlers = {
        handleClickClose: handleClickClose,
        handleClickClear: function() {
            dispatch({
                type: "changeAreaIds",
                payload: {
                    areaIds: []
                }
            });
        }
    };
    var jobTaskClickHandlers = {
        handleClickClose: handleClickClose,
        handleClickClear: function() {
            dispatch({
                type: "changeJobTaskIds",
                payload: {
                    jobTaskIds: []
                }
            });
        }
    };
    var _regions, _workingHourOptions, _licenses, _features, _jobBenefits, _jobTasks;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            displayMode === "area-modal" && /*#__PURE__*/ (0,jsx_runtime.jsx)(AreaModal, {
                areaTreeData: areaListData,
                areaIds: areaIds !== null && areaIds !== void 0 ? areaIds : undefined,
                handlers: areaClickHandlers
            }),
            displayMode === "search-modal" && /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchConditionModal, {
                areaIds: areaIds !== null && areaIds !== void 0 ? areaIds : undefined,
                handlers: searchConditionClickHandlers,
                conditionList: /*#__PURE__*/ (0,jsx_runtime.jsx)(ConditionsList, {
                    regions: (_regions = areaListData === null || areaListData === void 0 ? void 0 : areaListData.areaTree.regions) !== null && _regions !== void 0 ? _regions : [],
                    workingHourOptions: (_workingHourOptions = workingHourOptionsData === null || workingHourOptionsData === void 0 ? void 0 : workingHourOptionsData.workingHourOptionList.workingHourOptions) !== null && _workingHourOptions !== void 0 ? _workingHourOptions : [],
                    licenses: (_licenses = licenseListData === null || licenseListData === void 0 ? void 0 : licenseListData.licenseList.licenses) !== null && _licenses !== void 0 ? _licenses : [],
                    facilityFeatures: (_features = facilityFeatureListData === null || facilityFeatureListData === void 0 ? void 0 : facilityFeatureListData.facilityFeatureList.features) !== null && _features !== void 0 ? _features : [],
                    jobBenefits: (_jobBenefits = jobBenefitsData === null || jobBenefitsData === void 0 ? void 0 : jobBenefitsData.jobBenefitList.jobBenefits) !== null && _jobBenefits !== void 0 ? _jobBenefits : [],
                    jobTasks: (_jobTasks = jobTasksData === null || jobTasksData === void 0 ? void 0 : jobTasksData.jobTaskList.jobTasks) !== null && _jobTasks !== void 0 ? _jobTasks : []
                })
            }),
            displayMode === "license-modal" && licenseListData && /*#__PURE__*/ (0,jsx_runtime.jsx)(LicenseModal, {
                handlers: licenseClickHandlers,
                licenseList: /*#__PURE__*/ (0,jsx_runtime.jsx)(LicenseList, {
                    licenses: licenseListData.licenseList.licenses
                })
            }),
            displayMode === "facility-feature-modal" && facilityFeatureListData && /*#__PURE__*/ (0,jsx_runtime.jsx)(FacilityFeatureListModal, {
                handlers: facilityFeatureClickHandlers,
                facilityFeatureList: /*#__PURE__*/ (0,jsx_runtime.jsx)(FacilityFeatureList, {
                    facilityFeatures: facilityFeatureListData === null || facilityFeatureListData === void 0 ? void 0 : facilityFeatureListData.facilityFeatureList.features
                })
            }),
            displayMode === "working-hour-option-modal" && workingHourOptionsData && /*#__PURE__*/ (0,jsx_runtime.jsx)(WorkingHourOptionModal, {
                handlers: workingHourOptionClickHandlers,
                workingHourOptionList: /*#__PURE__*/ (0,jsx_runtime.jsx)(WorkingHourOptionList, {
                    workingHourOptions: workingHourOptionsData === null || workingHourOptionsData === void 0 ? void 0 : workingHourOptionsData.workingHourOptionList.workingHourOptions
                })
            }),
            displayMode === "job-benefit-modal" && jobBenefitsData && /*#__PURE__*/ (0,jsx_runtime.jsx)(JobBenefitModal, {
                handlers: jobBenefitClickHandlers,
                jobBenefitList: /*#__PURE__*/ (0,jsx_runtime.jsx)(JobBenefitList, {
                    jobBenefits: jobBenefitsData.jobBenefitList.jobBenefits
                })
            }),
            displayMode === "job-task-modal" && jobTasksData && /*#__PURE__*/ (0,jsx_runtime.jsx)(JobTaskModal, {
                handlers: jobTaskClickHandlers,
                jobTaskList: /*#__PURE__*/ (0,jsx_runtime.jsx)(JobTaskList, {
                    jobTasks: jobTasksData.jobTaskList.jobTasks || []
                })
            }),
            displayMode === "sort-setting-modal" && sortOptionsData && /*#__PURE__*/ (0,jsx_runtime.jsx)(SortSettingModal, {
                sortOptions: sortOptionsData.sortOptionList.options
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/client/components/recruitments/index.tsx










var RecruitmentsUI = function(param) {
    var token = param.token;
    var ref = useRecruitmentListContext(), displayMode = ref.ui.displayMode;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "jsx-2f98573506ce448f" + " " + "max-w-5xl mx-auto",
                children: [
                    displayMode === "list" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "jsx-2f98573506ce448f" + " " + "sticky top-0 w-full  bg-white border-b border-gray z-10",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchForm, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Calendar, {})
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "jsx-2f98573506ce448f" + " " + "available-wrapper",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AvailableDates, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RecruitmentList, {})
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ActionsFooter/* default */.Z, {
                                token: token
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchModal, {})
                ]
            }),
            (0,jsx_runtime.jsx)((style_default()), {
                id: "2f98573506ce448f",
                children: ".available-wrapper.jsx-2f98573506ce448f{margin:20px 20px 0}.available-link.jsx-2f98573506ce448f{padding:11px 20px;border:1px solid#d8d8d8;-webkit-box-shadow:1px 1px 10px rgba(0,0,0,.1);-moz-box-shadow:1px 1px 10px rgba(0,0,0,.1);box-shadow:1px 1px 10px rgba(0,0,0,.1);-webkit-border-radius:10px;-moz-border-radius:10px;border-radius:10px;-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center}.icon-bg.jsx-2f98573506ce448f{width:50px;height:50px;-webkit-border-radius:50%;-moz-border-radius:50%;border-radius:50%;-webkit-box-pack:center;-webkit-justify-content:center;-moz-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;margin-right:16px}"
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
;// CONCATENATED MODULE: ./src/client/reducers/recruitents/RecruitmentList/index.ts



var recruitmentListReducer = function(state, action) {
    switch(action.type){
        case "resetSearchQueryParams":
            {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                    // 検索の絞り込み条件だけをリセットしたいのであって、日付までリセットしてはいけない
                    searchQueryParams: {
                        date: state.searchQueryParams.date,
                        areaIds: null,
                        licenseIds: null,
                        jobBenefitIds: null,
                        workingHourOptionIds: null,
                        maximumWorkingHours: null,
                        jobTaskIds: null,
                        maximumDailyWage: null,
                        minimumDailyWage: null,
                        facilityFeatureIds: null,
                        sortOptionId: null,
                        onlyRecruiting: null
                    }
                });
            }
        case "changeDate":
            {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                    searchQueryParams: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state.searchQueryParams), {
                        date: action.payload.date
                    })
                });
            }
        case "changeAreaIds":
            {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                    searchQueryParams: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state.searchQueryParams), {
                        areaIds: action.payload.areaIds
                    })
                });
            }
        case "changeLicenseIds":
            {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                    searchQueryParams: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state.searchQueryParams), {
                        licenseIds: action.payload.licenseIds
                    })
                });
            }
        case "selectFacilityFeatureIds":
            {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                    searchQueryParams: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state.searchQueryParams), {
                        facilityFeatureIds: action.payload.facilityFeatureIds
                    })
                });
            }
        case "changeJobBenefitIds":
            {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                    searchQueryParams: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state.searchQueryParams), {
                        jobBenefitIds: action.payload.jobBenefitIds
                    })
                });
            }
        case "changeWorkingHourOptionIds":
            {
                var ref;
                var workingHourOptionId = action.payload.workingHourOptionId;
                if ((ref = state.searchQueryParams.workingHourOptionIds) === null || ref === void 0 ? void 0 : ref.includes(workingHourOptionId)) {
                    var ref1;
                    var newIds = (ref1 = state.searchQueryParams.workingHourOptionIds) === null || ref1 === void 0 ? void 0 : ref1.filter(function(id) {
                        return id !== workingHourOptionId;
                    }).filter(function(id) {
                        return typeof id === "string";
                    });
                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                        searchQueryParams: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state.searchQueryParams), {
                            workingHourOptionIds: newIds
                        })
                    });
                }
                if (state.searchQueryParams.workingHourOptionIds) {
                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                        searchQueryParams: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state.searchQueryParams), {
                            workingHourOptionIds: (0,_to_consumable_array/* default */.Z)(state.searchQueryParams.workingHourOptionIds).concat([
                                workingHourOptionId
                            ])
                        })
                    });
                }
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                    searchQueryParams: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state.searchQueryParams), {
                        workingHourOptionIds: [
                            workingHourOptionId
                        ]
                    })
                });
            }
        case "clearWorkingHourOptionIds":
            {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                    searchQueryParams: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state.searchQueryParams), {
                        workingHourOptionIds: null
                    })
                });
            }
        case "selectSortOptionId":
            {
                var sortOptionId = action.payload.sortOptionId;
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                    searchQueryParams: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state.searchQueryParams), {
                        sortOptionId: state.searchQueryParams.sortOptionId === sortOptionId ? null : sortOptionId
                    })
                });
            }
        case "clearSortOptionId":
            {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                    searchQueryParams: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state.searchQueryParams), {
                        sortOptionId: null
                    })
                });
            }
        case "changeMaximumDailyWage":
            {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                    searchQueryParams: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state.searchQueryParams), {
                        maximumDailyWage: action.payload.maximumDailyWage
                    })
                });
            }
        case "changeMinimumDailyWage":
            {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                    searchQueryParams: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state.searchQueryParams), {
                        minimumDailyWage: action.payload.minimumDailyWage
                    })
                });
            }
        case "changeDisplayMode":
            {
                var newModeHistory = state.ui.modeHistory;
                newModeHistory.push(action.payload.displayMode);
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                    ui: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state.ui), {
                        displayMode: action.payload.displayMode,
                        modeHistory: newModeHistory
                    })
                });
            }
        case "changeMaximumWorkingHours":
            {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                    searchQueryParams: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state.searchQueryParams), {
                        maximumWorkingHours: action.payload.maximumWorkingHours
                    })
                });
            }
        case "changeJobTaskIds":
            {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                    searchQueryParams: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state.searchQueryParams), {
                        jobTaskIds: action.payload.jobTaskIds
                    })
                });
            }
        case "changeOnlyRecruiting":
            {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                    searchQueryParams: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state.searchQueryParams), {
                        onlyRecruiting: action.payload.onlyRecruiting
                    })
                });
            }
        default:
            throw new Error("Unexpected action type in RecruitingList reducer");
    }
};

// EXTERNAL MODULE: ./src/utils/seo.ts
var seo = __webpack_require__(68412);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/isValid/index.js
var isValid = __webpack_require__(12274);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/isAfter/index.js
var isAfter = __webpack_require__(42699);
;// CONCATENATED MODULE: ./src/client/hooks/recruitment/RecruitmentList/createRecruitmentSearchInput.ts
// URLのクエリパラメータ(NextのRouterのquery)からSearchRecruitment Query のinputを作成

var createRecruitmentSearchInput = function(params, currentDate) {
    // 日付の初期値はcurrentDate
    var result = {
        date: (0,format/* default */.Z)(currentDate, "yyyy-MM-dd"),
        areaIds: null,
        licenseIds: null,
        jobBenefitIds: null,
        workingHourOptionIds: null,
        maximumWorkingHours: null,
        jobTaskIds: null,
        maximumDailyWage: null,
        minimumDailyWage: null,
        facilityFeatureIds: null,
        sortOptionId: null,
        onlyRecruiting: null
    };
    // 日付は複数指定不可なので、dateプロパティの型が文字列のときだけ考慮する
    if ("date" in params && typeof params.date == "string") {
        var parsedDate = new Date(params.date);
        // Ucareの募集検索は過去の日付で検索できないため、クエリパラメータのdateは当日もしくはそれ以降のみ許可
        if ((0,isValid/* default */.Z)(parsedDate) && ((0,isSameDay/* default */.Z)(parsedDate, currentDate) || (0,isAfter/* default */.Z)(parsedDate, currentDate))) {
            result.date = params.date;
        }
    }
    if (params === null || params === void 0 ? void 0 : params.area_ids) {
        result.areaIds = [
            params.area_ids
        ].flat(1);
    }
    if (params === null || params === void 0 ? void 0 : params.license_ids) {
        result.licenseIds = [
            params.license_ids
        ].flat(1);
    }
    if (params === null || params === void 0 ? void 0 : params.facility_feature_ids) {
        result.facilityFeatureIds = [
            params.facility_feature_ids
        ].flat(1);
    }
    if (params === null || params === void 0 ? void 0 : params.job_benefit_ids) {
        result.jobBenefitIds = [
            params.job_benefit_ids
        ].flat(1);
    }
    if (params === null || params === void 0 ? void 0 : params.working_hour_option_ids) {
        result.workingHourOptionIds = [
            params.working_hour_option_ids
        ].flat(1);
    }
    if ((params === null || params === void 0 ? void 0 : params.sort_option_id) && typeof params.sort_option_id === "string") {
        result.sortOptionId = params.sort_option_id;
    }
    if (params === null || params === void 0 ? void 0 : params.maximum_working_hours) {
        result.maximumWorkingHours = Number([
            params.maximum_working_hours
        ].flat(1)[0]);
    }
    if (params === null || params === void 0 ? void 0 : params.minimum_daily_wage) {
        result.minimumDailyWage = Number([
            params.minimum_daily_wage
        ].flat(1)[0]);
    }
    if (params === null || params === void 0 ? void 0 : params.maximum_daily_wage) {
        result.maximumDailyWage = Number([
            params.maximum_daily_wage
        ].flat(1)[0]);
    }
    if (params === null || params === void 0 ? void 0 : params.job_task_ids) {
        result.jobTaskIds = [
            params.job_task_ids
        ].flat(1);
    }
    if (params === null || params === void 0 ? void 0 : params.only_recruiting) {
        result.onlyRecruiting = true;
    }
    return result;
};

;// CONCATENATED MODULE: ./src/client/hooks/recruitment/RecruitmentList/useSearchQueryParams.ts


var useSearchQueryParams = function(currentDate) {
    var router = (0,next_router.useRouter)();
    return createRecruitmentSearchInput(router.query, currentDate);
};

;// CONCATENATED MODULE: ./src/pages/recruitments.tsx












var Index = function(param) {
    var areaIds = param.areaIds, token = param.token;
    var currentDate = new Date();
    var queryInput = useSearchQueryParams(currentDate);
    var initialState = createInitialState(currentDate, areaIds);
    var initialStateForReducer = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, initialState), {
        // URLのクエリパラメータから募集検索Queryの入力を復元している
        searchQueryParams: (0,_object_spread/* default */.Z)({}, queryInput)
    });
    var ref = (0,react.useReducer)(recruitmentListReducer, initialStateForReducer), state = ref[0], dispatch = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeadTag/* default */.Z, {
                title: seo/* seoTagValues.common.title */.g.common.title,
                description: seo/* seoTagValues.common.description */.g.common.description,
                keywords: seo/* seoTagValues.common.description */.g.common.description,
                canonical: "".concat("https://stage.ucare.works").concat(paths/* paths.recruitments.index */.H.recruitments.index)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(RecruitmentListContext.Provider, {
                value: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                    dispatch: dispatch
                }),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RecruitmentsUI, {
                    token: token
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ActionsFooter/* default */.Z, {
                token: token
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ var recruitments = (Index);


/***/ }),

/***/ 68412:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ seoTagValues; }
/* harmony export */ });
var seoTagValues = {
    common: {
        title: "Ucare - USEN GROUPが提供する 介護・看護の専門人材向けワークシェアリングアプリ",
        description: "UcareはUSEN GROUPが提供する介護・看護の専門人材と人手不足で困っている介護施設・医療機関をつなぐワークシェアリングアプリです。",
        keywords: "Ucare,U care,ユーケア,ユウケア,ゆうけあ,ゆーけあ, ワークシェアリング, 介護,医療,介護・医療,スポット,掛け持ち バイト,バイト 即日,単発 バイト,介護 バイト おすすめ"
    }
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1664,1513,9330,9999,7203,3549,9774,2888,179], function() { return __webpack_exec__(33706), __webpack_exec__(23929); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);